import Popup from "reactjs-popup";
import styled from "styled-components";

export const StyledPopup = styled(Popup)`
  &-overlay {
    z-index: 10000 !important;
  }
  &-content {
    width: 540px !important;
    min-height: auto !important;
    height: auto !important;
    box-sizing: border-box !important;
    z-index: 10001 !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 10px;
    box-shadow: 1px 1px 4px 0 rgba(22, 22, 29, 0.3);
    background-color: #fff;
    margin: auto;
    & .container {
      box-sizing: border-box;
      width: 100%;
      min-height: auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      gap: 16px;
      padding: 32px 32px 24px;
      border: none;
      border-radius: 10px;
      background-color: #fff;
      cursor: default;
      overflow: visible;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
      width: calc(100vw - 32px) !important;
      max-width: 540px !important;
      min-height: auto !important;

      & .container {
        min-height: auto;
        padding: 24px 20px;
      }
    }
  }
`;

export const HeadCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const Content = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0;
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const TitleGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 27px;
`;

export const Title = styled.h3`
  width: 100%;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #494949;
`;

export const Intro = styled.p`
  width: 100%;
  margin: 0;
  font-size: 15px;
  line-height: 1.4;
  text-align: center;
  color: #494949;
  white-space: pre-line;
`;

export const RequirementsList = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RequirementRow = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RequirementIcon = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Cuadrado que contiene el círculo del estado pendiente (24x24).
export const CircleBox = styled.div`
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #FFD100;
  border-radius: 4px;
  overflow: hidden;
`;

export const CheckBox = styled.div`
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1.5px #67c940;
  border-radius: 4px;
  overflow: hidden;
`;

export const RequirementBody = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const RequirementLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #494949;
`;

export const RequirementDescription = styled.span`
  font-size: 12px;
  color: #494949;
  line-height: 1.4;
  white-space: pre-line;
`;

export const RequirementAction = styled.a`
  flex: 0 0 auto;
  align-self: center;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 152px;
  height: 41px;
  padding: 10px 24px;
  border: solid 1px #737377;
  border-radius: 10px;
  box-shadow: 1px 1px 4px 0 rgba(22, 22, 29, 0.3);
  font-size: 16px;
  font-weight: 600;
  color: #16161d;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const BottomCard = styled.div`
  width: 100%;
  & button {
    box-sizing: border-box;
    width: 100%;
    height: 67px;
    font-size: 18px;
    font-weight: bold;
    margin-right: 0;
    border-radius: 5px;
    padding: 20px 40px;
  }
`;
